import { createContext, useCallback, useRef, useState } from "react";

export const VideoContext = createContext()

export const VideoContextProvider = ({ children }) => {
    const videoRef = useRef()
    const [isLoading, setIsLoading] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false)
    const [currentTime, setCurrentTime] = useState(0)
    const [duration, setDuration] = useState(0)
    const seekTo = useCallback((timeInSeconds) => {
        if (!videoRef.current) return
        const newTime = Math.max(0, Math.min(timeInSeconds, duration));
        videoRef.current.currentTime = newTime;
    }, [duration])
    // 播放/暂停控制
    const togglePlayPause = useCallback(() => {
        if (!videoRef.current) return;
        if (isPlaying) {
            videoRef.current.pause();
        } else {
            videoRef.current.play().catch(error => {
                console.error('播放失败:', error);
            });
        }
    }, [isPlaying]);
    return (
        <VideoContext.Provider value={{
            videoRef,
            isLoading,
            setIsLoading,
            isPlaying,
            setIsPlaying,
            currentTime,
            setCurrentTime,
            duration,
            setDuration,
            seekTo,
            togglePlayPause,
        }}>
            {children}
        </VideoContext.Provider>
    )
}